export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-1-960-1b4dd24e48964be029fb417de35560c8.webp";